import { ReactElement, Fragment, memo } from 'react';

import { OnAnswerChange, RenderingFieldGroup } from '@zinnia/form-engine-sdk';
import { Language } from '@breathelife/types';

import { StyleVariant } from '../../FieldGenerator/FieldGenerator';
import { QuestionContent } from './QuestionContent';
import { Container, QuestionText, QuestionTitle } from './Styles';
import { ReactHtmlParser } from '@breathelife/ui-components';

type QuestionProps = {
  fieldGroup: RenderingFieldGroup;
  onAnswerChange: OnAnswerChange;
  onAnswerComplete: (fieldId: string, answer: any, previousAnswer: any) => void;
  styleVariant: StyleVariant;
  locale?: Language;
  iconMap?: Record<string, string>;
  onInfoIconClick?: () => void;
  onError?: (fieldId: string, error?: string) => void;
  focusedIncompleteFieldId?: string;
};

export const Question = memo(InnerQuestion);

export function InnerQuestion(props: QuestionProps): ReactElement {
  const {
    fieldGroup,
    onAnswerChange,
    onAnswerComplete,
    styleVariant,
    locale,
    iconMap,
    onInfoIconClick,
    onError,
    focusedIncompleteFieldId,
  } = props;

  return (
    <Container styleVariant={styleVariant} key={fieldGroup.id} data-testid={'question'}>
      <Fragment>
        {fieldGroup.title && (
          <QuestionTitle styleVariant={styleVariant}>
            <ReactHtmlParser html={fieldGroup.title} />
          </QuestionTitle>
        )}
        {fieldGroup.text && (
          <QuestionText styleVariant={styleVariant}>
            <ReactHtmlParser html={fieldGroup.text} />
          </QuestionText>
        )}
        <QuestionContent
          fields={fieldGroup.fields}
          onAnswerChange={onAnswerChange}
          onAnswerComplete={onAnswerComplete}
          styleVariant={styleVariant}
          locale={locale}
          iconMap={iconMap}
          onInfoIconClick={onInfoIconClick}
          onError={onError}
          focusedIncompleteFieldId={focusedIncompleteFieldId}
        />
      </Fragment>
    </Container>
  );
}
